export default {
  getUpdateChallengeObject: (state)=> state.updateChallengeObject,
  getNextPreviousObject: (state) => state.getNextPreviousObject,
  getSideBarChallenge: (state) => state.sideBarChallenge,
}
